(function ($) {

  //SLIDER ACCESSIBLE (https://accessible360.github.io/accessible-slick/)
  $('.adhoc-slider').slick({
    mobileFirst: true,
    dots: true,
    infinite: true,
    fade: true,
  });

  $('.data-slider').slick({
    mobileFirst: true,
    dots: false,
    arrows: false,
    infinite: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000
  });

  $('.connected-apps-slider').slick({
    arrowsPlacement: 'beforeSlides',
    infinite: true,
    autoplay: true
  });

  $('.parterns-slider').slick({
    arrowsPlacement: 'beforeSlides',
    infinite: true,
    autoplay: true,
    centerMode: true,
    variableWidth: false,
    //centerPadding: '50px',
    slidesToShow: 1,
    responsive: [
      {
      breakpoint: 600,
      settings: {
        centerMode: true,
        centerPadding: '80px',
        slidesToShow: 1
      }
    }
  ]
  });

  $('.testimonial-slider').slick({
    prevArrow: '.testimonial-slider-left',
    nextArrow: '.testimonial-slider-right',
    dots: true
  });

  $('.blog-slider').slick({
    prevArrow: '.blog-slider-left',
    nextArrow: '.blog-slider-right',
    infinite: true,
    arrowsPlacement: 'beforeSlides',
    centerMode: true,
    centerPadding: '100px',
    slidesToShow: 4,
    responsive: [{
        breakpoint: 1200,
        settings: {
          centerMode: true,
          centerPadding: '80px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 800,
        settings: {
          centerMode: true,
          centerPadding: '50px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: true,
          centerPadding: '32px',
          slidesToShow: 1
        }
      }
    ]
  });

  $('.erp-slider').slick({
    prevArrow: '.erp-slider-left',
    nextArrow: '.erp-slider-right',
    infinite: true,
    arrowsPlacement: 'beforeSlides',
    centerMode: false,
    centerPadding: '100px',
    slidesToShow: 4,
    responsive: [{
        breakpoint: 1250,
        settings: {
          centerMode: true,
          centerPadding: '80px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1100,
        settings: {
          centerMode: true,
          centerPadding: '50px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          settings: "unslick"
        }
      }
    ]
  });

  $('.payment-slider').slick({
    prevArrow: '.payment-slider-left',
    nextArrow: '.payment-slider-right',
    infinite: true,
    arrowsPlacement: 'beforeSlides',
    centerMode: false,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          settings: "unslick"
        }
      }
    ]
  });

  $('.use-case-slider').slick({
    prevArrow: '.use-case-slider-left',
    nextArrow: '.use-case-slider-right',
    infinite: true,
    arrowsPlacement: 'beforeSlides',
    centerMode: true,
    variableWidth: true,
    centerPadding: '32px',
    slidesToShow: 1
  });
})(jQuery);
